import React, { useState, useEffect } from 'react';
import { Card, Typography, Input, Space, Table } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words'; // Assuming you are using a library for highlighting text
import axios from 'axios';

function ComprasFeitas() {
  // Define state variables to hold your data
  const [totalPurchase, setTotalPurchase] = useState(0);
  const [successfulTransactions, setSuccessfulTransactions] = useState([]);
  const [unsuccessfulTransactions, setUnsuccessfulTransactions] = useState([]);
  const [monthlyFee, setMonthlyFee] = useState(0);
  const [transactionData, setTransactionData] = useState([]);

  const [searchCriteria, setSearchCriteria] = useState({
    customerName: "",
    token: "",
    metodoPagamento: ""
  });

  const columns = [
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Customer Name"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <button
              type="button"
              onClick={() => {
                clearFilters();
                setSearchCriteria({ ...searchCriteria, customerName: '' });
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </button>
            <button
              type="button"
              onClick={() => {
                confirm();
                setSearchCriteria({ ...searchCriteria, customerName: selectedKeys[0] });
              }}
              size="small"
              style={{ width: 90 }}
            >
              OK
            </button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => this.searchInput.select(), 100);
        }
      },
      render: (text) => (searchCriteria.customerName ? <Highlighter highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }} searchWords={[searchCriteria.customerName]} autoEscape textToHighlight={text ? text.toString() : ''} /> : text),
    },
    {
      title: 'Token',
      dataIndex: 'token',
      key: 'token',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Token"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <button
              type="button"
              onClick={() => {
                clearFilters();
                setSearchCriteria({ ...searchCriteria, token: '' });
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </button>
            <button
              type="button"
              onClick={() => {
                confirm();
                setSearchCriteria({ ...searchCriteria, token: selectedKeys[0] });
              }}
              size="small"
              style={{ width: 90 }}
            >
              OK
            </button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => this.searchInput.select(), 100);
        }
      },
      render: (text) => (searchCriteria.token ? <Highlighter highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }} searchWords={[searchCriteria.token]} autoEscape textToHighlight={text ? text.toString() : ''} /> : text),
    },
    {
      title: 'Meter Number',
      dataIndex: 'meter_number',
      key: 'meter_number',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Meter Number"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <button
              type="button"
              onClick={() => {
                clearFilters();
                setSearchCriteria({ ...searchCriteria, meterNumber: '' });
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </button>
            <button
              type="button"
              onClick={() => {
                confirm();
                setSearchCriteria({ ...searchCriteria, meterNumber: selectedKeys[0] });
              }}
              size="small"
              style={{ width: 90 }}
            >
              OK
            </button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => this.searchInput.select(), 100);
        }
      },
      render: (text) => (searchCriteria.meterNumber ? <Highlighter highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }} searchWords={[searchCriteria.meterNumber]} autoEscape textToHighlight={text ? text.toString() : ''} /> : text),
    },
    {
        title: 'Timestamp',
        dataIndex: 'timestamp',
        key: 'timestamp',
        // Add filterDropdown, filterIcon, onFilterDropdownVisibleChange, and render similar to other columns
      },
      {
        title: 'Error Message',
        dataIndex: 'error_message',
        key: 'error_message',
        // Add filterDropdown, filterIcon, onFilterDropdownVisibleChange, and render similar to other columns
      },
  ];
  

  useEffect(() => {
    // Fetch data from your API or wherever it's stored
    fetchData();
  }, []); // Empty dependency array ensures useEffect runs only once, similar to componentDidMount
  const fetchData = async () => {
    try {
      const response = await axios.get(`${localStorage.getItem('url')}/web/relatorios_diarios/`, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      const jsonData = response.data;
      console.log(jsonData)
      setTotalPurchase(jsonData.total_purchases_today);
      setSuccessfulTransactions(jsonData.suwccessful_transactions);
      setUnsuccessfulTransactions(jsonData.unsuccessful_transactions);
      setMonthlyFee(jsonData.cumulative_monthly_fee);
      setTransactionData(jsonData.all_transactions);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <div>
      <h2>Resumo das Compras do Dia</h2>

      <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
        {/* Total Purchase Card */}
        <Card>
          <Typography gutterBottom>Total de Compras</Typography>
          <Typography variant="h5">{totalPurchase}</Typography>
        </Card>

        {/* Successful Transactions Card */}
        <Card>
          <Typography gutterBottom>Transações Bem-sucedidas</Typography>
          <Typography variant="h5">{successfulTransactions}</Typography>
        </Card>

        {/* Unsuccessful Transactions Card */}
        <Card>
          <Typography gutterBottom>Transações Mal-sucedidas</Typography>
          <Typography variant="h5">{unsuccessfulTransactions}</Typography>
        </Card>

        {/* Monthly Fee Card */}
        <Card>
          <Typography gutterBottom>Taxa Fixa Mensal</Typography>
          <Typography variant="h5">{monthlyFee}</Typography>
        </Card>
      </div>

      {/* Transaction Data Table */}
      <Table
        dataSource={transactionData}
        columns={columns}
        pagination={{ pageSize: 4 }}
      />
    </div>
  );
}

export default ComprasFeitas;
